const ContractComponent = {
    data()
    {
        return {
            currentStep: 1,
            totalPrice: 0,
            errors: {},
            loading: false,
        };
    },

    methods: {
        calculateTotal()
        {
            let total = 0;

            const checkedInputs = document.querySelectorAll(
                '#Contract input[type="radio"]:checked, #Contract input[type="checkbox"]:checked'
            );

            checkedInputs.forEach((input) => {
                total += Number(input.dataset.price || 0);
            });

            this.totalPrice = total;
        },

        scrollToTop(duration = 800)
        {
            const start = window.pageYOffset;
            const startTime = performance.now();

            const animate = (currentTime) => {

                const elapsed = currentTime - startTime;
                const progress = Math.min(elapsed / duration, 1);

                const ease =
                    1 - Math.pow(1 - progress, 3);

                window.scrollTo(
                    0,
                    start * (1 - ease)
                );

                if ( progress < 1 ) {
                    requestAnimationFrame(animate);
                }
            };

            requestAnimationFrame(animate);
        },

        goToStepTwo()
        {
            this.calculateTotal();

            if ( this.totalPrice <= 0 ) {
                window.globalState.addNotification(
                    'Выберите хотя бы один пункт.'
                );
                return;
            }

            this.currentStep = 2;

            this.$nextTick(() => {
                this.scrollToTop();
            });
        },

        backToStepOne()
        {
            this.currentStep = 1;

            this.$nextTick(() => {
                this.scrollToTop();
            });
        },

        clearErrors() {
            this.errors = {};
        },

        collectSelectedServices()
        {
            const result = [];

            const checkedInputs = document.querySelectorAll(
                '#Contract [data-contract-item]:checked'
            );

            checkedInputs.forEach((input) => {

                result.push({
                    group: input.dataset.group,
                    name: input.value,
                    price: Number(input.dataset.price || 0),
                    field: input.name
                });

            });

            return result;
        },

        async sendContract() {
            this.loading = true;
            this.clearErrors();

            try {
                const form_data = new FormData(document.getElementById('formContract'));

                form_data.append(
                    'total_price',
                    this.totalPrice
                );

                form_data.append(
                    'selected_services',
                    JSON.stringify(
                        this.collectSelectedServices()
                    )
                );

                const response = await fetch(window.appConfig.routes.sendContract, {
                    method: 'post',
                    headers: {
                        'X-CSRF-TOKEN': window.appConfig.csrfToken,
                        'Accept': 'application/json'
                    },
                    body: form_data
                });

                const data = await response.json();

                if (response.ok) {
                    this.currentStep = 3;

                    this.$nextTick(() => {
                        this.scrollToTop();
                    });
                } else if (response.status === 422) {
                    this.errors = data;
                    globalState.addNotification(
                        `Пожалуйста, заполните все необходимые поля.`
                    );
                } else {
                    this.messageError = data.message || "В ходе отправки произошла ошибка";
                }
            } catch (error) {
                this.messageError = "Ошибка сети. Попробуйте еще раз.";
            } finally {
                this.loading = false;
            }
        },
    },

    computed: {
        formattedTotalPrice()
        {
            return new Intl.NumberFormat('ru-RU').format(this.totalPrice);
        },
    },

    mounted()
    {
        this.calculateTotal();

        document.addEventListener('change', (event) => {

            if (
                event.target.matches('#Contract input[type="radio"]') ||
                event.target.matches('#Contract input[type="checkbox"]')
            ) {
                this.calculateTotal();
            }

        });
    },
};

window.ContractComponent = ContractComponent;